import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=3e0d00a9&scoped=true"
import script from "./admins.vue?vue&type=script&lang=js"
export * from "./admins.vue?vue&type=script&lang=js"
import style0 from "./admins.vue?vue&type=style&index=0&id=3e0d00a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0d00a9",
  null
  
)

export default component.exports